import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";

export function subscribeToProfile(userId, callback) {
  return onSnapshot(doc(db, "users", userId), (snap) => {
    callback(snap.exists() ? { id: snap.id, ...snap.data() } : null);
  });
}
